export const OPTIONS_GET = 'OPTIONS_GET';
export const OPTIONS_CANCELLED = 'OPTIONS_CANCELLED';
export const OPTIONS_SUCCESS = 'OPTIONS_SUCCESS';
export const OPTIONS_ERROR_FROM_REMOTE = 'OPTIONS_ERROR_FROM_REMOTE';

export const fetchOptions = (remoteSettings, fetchId) => ({
  type: OPTIONS_GET,
  fetchId,
  payload: remoteSettings,
});
